<template>
	<div class="uk-width-1-1" :class="eventItem.status === 'past' ? '' : 'dr-upcoming-event'">
        <div :class="eventItem.status === 'past' ? 'dr-past-event uk-padding-bottom' : ''">
            
            <a :href="this.eventItem.permalink" class="uk-card-small uk-card-hover uk-card-event uk-overflow-hidden">

                <div class="uk-width-expand uk-position-relative uk-flex uk-flex-column uk-flex-start" :class="eventItem.status === 'past' ? 'uk-background-white' : 'uk-dark uk-card-body dr-upcoming-event-card'">

                    <div class="uk-width-expand">
                        <div class="uk-badge uk-overflow-ellipsis uk-badge-orange uk-margin-small-bottom" :class="eventItem.status === 'past' ? 'uk-display-none ' : ''">{{ $t("filters." + eventItemType)}}</div>

                        <div class="uk-flex uk-flex-middle">
                            <div class="uk-width-expand">
                                <div class="uk-card-event-label uk-text-uppercase uk-margin-xsmall-bottom uk-text-muted uk-text-overline" v-if="eventItem.status === 'past'">{{ getDate('month') }} {{ getDate('day') }}</div>


                                <div :class="eventItem.status === 'past' ? '' : 'dr-upcoming-event-title'">
                                    <div class="uk-margin-remove-top uk-width-expand uk-event-title" :class="eventItem.status === 'past' ? 'uk-padding-right uk-margin-remove-bottom uk-h6' : 'uk-margin-small-bottom uk-h4'" v-if="eventItem.title" v-html="eventItem.title"></div>
                                </div>
                            </div>

                            <div class="uk-badge uk-overflow-ellipsis uk-badge-white-light uk-border-remove uk-margin-remove" v-if="eventItem.status === 'past'">{{ $t("filters." + eventItemType)}}</div>
                        </div>

                        <div class="uk-flex uk-text-muted uk-text-small uk-text-font-default" v-if="eventItem.location_name">
                            <span class="uk-icon uk-margin-xsmall-right uk-flex" uk-icon="icon: location;ratio:0.67"/>
                            <div>{{ eventItem.location_name }}</div>
                        </div>

                        

                    </div>

                    <div class="uk-margin-top uk-margin-auto-top dr-upcoming-event-date" :class="eventItem.status === 'past' ? 'uk-display-none ' : ''">{{ getDate('month') }} {{ getDate('day') }}</div>

                </div>
            </a>
            
        </div>
	</div>
</template>

<script>

    export default {
        name: "Event-item",
		props: ['eventItem', 'eventItemType'],
		data() {
			return {
				locale: window.events_data.locale
			}
		},
		methods: {
			getDate(type) {
				const startDate = this.$dayjs(this.eventItem.start_date);
				const endDate = this.$dayjs(this.eventItem.end_date);

				if (this.$dayjs(startDate).diff(this.$dayjs(endDate), type) === 0) {
					if (type === 'day') {
						return this.$dayjs(startDate).format('DD');
					} else if (type === 'month') {
						return this.$dayjs(startDate).format('MMMM');
					}
				} else {
					if (type === 'day') {
						return this.$dayjs(startDate).format('DD - ') + this.$dayjs(endDate).format('DD');
					} else if (type === 'month') {
						return this.$dayjs(startDate).format('MMMM - ') + this.$dayjs(endDate).format('MMMM');
					}
				}
			}
		},

	}
</script>

<style lang="scss">
    @import "assets/src/scss/misc/mixins";
    @import "assets/src/scss/uikit-theme/variables";

    .uk-card-event {
		display: flex;
		flex-direction: column;

		@include min(xs) {
			flex-direction: row-reverse;
		}


		.uk-card-event-image {
			padding-bottom: 50%;

			@include min(xs) {
				padding-bottom: 0;
			}
		}

		.uk-card-body {
			min-height: 350px;
			padding: 24px 24px 30px 24px;

			@include min(xs) {
				display: flex;
			}
		}

		.uk-card-event-label {
			@include min(xs) {
				position: static;
			}
		}
	}

    .dr-upcoming-event {
        min-height: 350px;
		background-color: rgba($global-muted-background, 0.5);
		transition: all 0.3s ease-in-out;

        &:hover {
            background-color: $global-purple-color;
        }


		&-date {
			position: relative;
			font-style: normal;
			font-weight: 400;
			text-transform: uppercase;
			padding-left: 20px;
			font-family: $global-monospace-font-family;
			font-size: $global-small-font-size;
			line-height: $global-line-height-12;
			letter-spacing: $global-letter-spacing-loose2;
			color: $global-black-color;

			&:after {
				background: #0b0b0b;
				content: "";
				position: absolute;
				margin: auto;
				left: 0;
				top: 0;
				bottom: 0;
				width: 10px;
				height: 5px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}

    .dr-past-event {
		border-bottom: 1px solid #e4e4e4;

        &:hover {
            .uk-event-title {
                text-decoration: underline;
                text-underline-offset: 3px;
            }

            .uk-badge-white-light {
                background-color: $global-black-color !important;
                color: $global-white-color !important;
            }
        }
	}

    .uk-event-title {
		line-height: 1.25;
        letter-spacing: -0.03em;
	}
    
</style>
